import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/widgets/SignIn/ui/SignIn.tsx");
